var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"distributed_response"}},[(_vm.distributed_to.message)?_c('div',{staticClass:"distributed_to_message",style:({
            borderColor: _vm.border_color()
        })},[_c('h3',[_vm._v("\n            "+_vm._s(_vm.$t('ui.scanner.helps.distributed_result'))+"：\n            "+_vm._s(_vm.distributed_to.message)+"\n        ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }